import { Stack, Skeleton } from '@chakra-ui/react';

export const SkeletonLoader = ({ skeletons = ['10px', '10px', '10px', '10px'], ...props }) => (
  <Stack flexGrow={1}>
    {skeletons.map((height, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Skeleton height={height} key={index} startColor="surface.F5F5F5" endColor="surface.g3" {...props} />
    ))}
  </Stack>
);
